import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ASIDE_HEADER: `${cleanedFilename(__filename)}-aside-header`,
};
